<template>
  <CContainer class="mt-4">
    <OrdersQuotes TypeDocument="C" TypeFilter="C" :IdCustomer="selectedIdDirectory" />
  </CContainer>
</template>
<script>
  import OrdersQuotes from "../../../datagrids/OrdersQuotes.vue";

  export default {
    data() {
      return {
        selectedIdDirectory: ""
      }    
    },
    components: {
      OrdersQuotes
    },
    methods: {
    },
    computed: {
      selectedDirectory() {
        return this.$store.state.selectedDirectory
      },
    },
    created() {
      this.selectedIdDirectory = this.$store.state.selectedDirectory.id_Directorio;
    },
    mounted(){
    }
  }
</script>
